function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3204 22.6758C16.1341 22.6758 15.9767 22.5156 15.9767 22.3317V21.3254C15.9767 21.1389 16.1341 20.9813 16.3204 20.9813C16.5066 20.9813 16.664 21.1415 16.664 21.3254V22.3317C16.664 22.5182 16.5066 22.6758 16.3204 22.6758Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5819 20.8998C21.5032 20.8998 21.4246 20.8735 21.3695 20.821C21.2383 20.6896 21.2121 20.5031 21.3432 20.3428C22.2429 19.284 22.799 17.9862 22.9301 16.6069C22.9564 16.4203 23.1164 16.289 23.3 16.3152C23.4862 16.3415 23.6173 16.4991 23.5911 16.6857C23.46 18.2226 22.8514 19.6256 21.8731 20.7921C21.7682 20.8709 21.6606 20.8972 21.5819 20.8972V20.8998Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9812 23.3117C16.8239 23.3117 16.6639 23.1803 16.6639 23.02C16.6376 22.8335 16.7688 22.6759 16.955 22.6496C18.2507 22.5182 19.4678 22.0401 20.4724 21.2204C20.6035 21.1153 20.816 21.1415 20.9471 21.2729C21.0521 21.4043 21.0258 21.6171 20.8947 21.7484C19.7852 22.6496 18.4344 23.2066 17.0337 23.3379C17.0075 23.3117 16.9812 23.3117 16.9812 23.3117Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6593 23.3117H15.633C14.2061 23.1803 12.8816 22.6233 11.772 21.7222C11.6409 21.6171 11.6147 21.4043 11.7196 21.2466C11.8245 21.0864 12.037 21.0864 12.1943 21.1941C13.1989 22.0164 14.416 22.5182 15.7117 22.6233C15.8979 22.6496 16.0291 22.8099 16.0029 22.9938C15.9766 23.1803 15.8166 23.3117 15.6593 23.3117Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0559 20.8998C10.951 20.8998 10.8697 20.8735 10.8173 20.7947C9.81267 19.6282 9.23037 18.199 9.09923 16.6883C9.073 16.5018 9.20414 16.3441 9.39037 16.3179C9.5766 16.2916 9.73398 16.423 9.76021 16.6095C9.89135 17.9862 10.4212 19.284 11.3471 20.3454C11.4782 20.4768 11.452 20.6896 11.3209 20.8236C11.2159 20.8761 11.1346 20.9024 11.0559 20.9024V20.8998Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4166 15.6821H9.39037C9.20414 15.6559 9.073 15.4956 9.09923 15.3117C9.2566 13.8562 9.81266 12.5032 10.7648 11.3656C10.8697 11.2342 11.0822 11.2079 11.2395 11.313C11.3707 11.4181 11.3969 11.6309 11.292 11.7885C10.4448 12.8211 9.91758 14.0401 9.78381 15.3642C9.73135 15.5508 9.57135 15.6821 9.41398 15.6821H9.4166Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6646 10.8874C11.5597 10.756 11.5597 10.5432 11.7171 10.4118C12.8554 9.48442 14.2036 8.92743 15.6567 8.79607C15.843 8.7698 16.0003 8.90116 16.0266 9.0877C16.0528 9.27161 15.9217 9.43187 15.7354 9.45814C14.4135 9.58951 13.1964 10.0939 12.1656 10.9425C11.9794 11.0476 11.7695 11.0214 11.662 10.89L11.6646 10.8874Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4987 10.9136C19.4678 10.065 18.2508 9.5632 16.9288 9.42921C16.7426 9.40293 16.6114 9.24267 16.6377 9.05876C16.6639 8.87223 16.8239 8.74087 17.0075 8.76714C18.4606 8.8985 19.8114 9.45548 20.9472 10.3829C21.0783 10.488 21.1046 10.7008 20.9996 10.8584C20.8685 11.0161 20.656 11.045 20.496 10.911L20.4987 10.9136Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2211 15.6821C23.0638 15.6821 22.9038 15.5507 22.9038 15.3905C22.7726 14.0663 22.2428 12.8473 21.3956 11.8148C21.2907 11.6834 21.2907 11.4706 21.448 11.3366C21.5792 11.2315 21.7916 11.2315 21.9228 11.3892C22.8487 12.5005 23.431 13.8798 23.5884 15.3353C23.6146 15.5218 23.4834 15.6795 23.2972 15.7057C23.2622 15.6882 23.236 15.6795 23.2185 15.6795L23.2211 15.6821Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3203 9.98621C15.8455 9.98621 15.4468 9.64204 15.3419 9.19278C15.3419 9.14023 15.3157 9.06142 15.3157 9.00624C15.3157 8.44927 15.7642 8 16.3203 8C16.8763 8 17.3249 8.44927 17.3249 9.00624C17.3249 9.05879 17.3249 9.1376 17.2986 9.19278C17.1937 9.64204 16.795 9.98621 16.3203 9.98621ZM16.3203 8.66207C16.134 8.66207 15.9767 8.81971 15.9767 9.00624V9.05878C16.0029 9.21905 16.134 9.32414 16.294 9.32414C16.454 9.32414 16.5852 9.21905 16.6114 9.05878V9.00624C16.6639 8.81971 16.5065 8.66207 16.3203 8.66207Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3202 24C15.7641 24 15.3156 23.5508 15.3156 22.9938V22.9412C15.3418 22.4105 15.7641 21.9875 16.294 21.9875C16.8238 21.9875 17.2461 22.4105 17.2723 22.9412V22.9938C17.3248 23.5508 16.8763 24 16.3202 24ZM16.0028 22.9938C16.0028 23.1803 16.1602 23.3117 16.3464 23.3117C16.5327 23.3117 16.6638 23.154 16.6638 22.9938V22.9675C16.6638 22.7836 16.5064 22.6496 16.3464 22.6496C16.1864 22.6496 16.0028 22.8099 16.0028 22.9938Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.551 11.736C20.2074 11.3918 20.155 10.8611 20.4461 10.4644C20.4723 10.4118 20.5248 10.3593 20.551 10.333C20.7373 10.1465 20.9733 10.0414 21.2383 10.0414C21.5032 10.0414 21.7419 10.1465 21.9517 10.333C22.3478 10.7297 22.3478 11.3392 21.9517 11.736C21.9255 11.7622 21.873 11.8148 21.8205 11.8411C21.4245 12.1327 20.8946 12.0801 20.551 11.736ZM21.2645 10.7008C21.1858 10.7008 21.1071 10.7271 21.0258 10.8059C21.0258 10.8059 20.9996 10.8322 20.9996 10.8585C20.8422 11.0713 20.9996 11.3892 21.2645 11.3892C21.3432 11.3892 21.3956 11.3629 21.4507 11.3366C21.4682 11.3191 21.4857 11.3103 21.5032 11.3103C21.6343 11.179 21.6343 10.9662 21.5032 10.8348C21.4245 10.756 21.3458 10.7034 21.2645 10.7034V10.7008Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3734 22.1451C11.1085 22.1451 10.8698 22.04 10.66 21.8535C10.1852 21.378 10.2901 20.6082 10.8724 20.2903C11.2422 20.0775 11.7196 20.13 12.0632 20.4479C12.3806 20.7658 12.4331 21.2151 12.2495 21.6144C12.197 21.7195 12.1445 21.801 12.0632 21.8798C11.877 22.0401 11.6409 22.1451 11.376 22.1451H11.3734ZM11.216 20.8735C11.1898 20.8998 11.1636 20.8998 11.1373 20.9261C11.0062 21.0575 11.0062 21.2703 11.1373 21.4016C11.1898 21.4542 11.2685 21.5067 11.376 21.5067C11.4547 21.5067 11.5334 21.4804 11.6147 21.4016C11.7459 21.2703 11.7459 21.0575 11.6147 20.9261C11.5098 20.821 11.3498 20.7947 11.2186 20.8735H11.216Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3025 16.98H23.1975C22.6939 16.9274 22.3241 16.5018 22.3241 16C22.3241 15.4982 22.6939 15.0726 23.1975 15.02H23.3287C23.8848 15.02 24.3333 15.4693 24.3333 16.0263C24.3333 16.5832 23.8585 16.98 23.3025 16.98ZM23.3025 15.6558H23.25C23.0926 15.6821 22.9589 15.8135 22.9589 15.9737C22.9589 16.134 23.09 16.2916 23.25 16.2916H23.2762C23.4625 16.2916 23.6198 16.134 23.6198 15.9474C23.6198 15.7609 23.4887 15.6558 23.3025 15.6558Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33796 16.9799C8.78189 16.9799 8.33337 16.5307 8.33337 15.9737C8.33337 15.4167 8.78189 14.9675 9.33796 14.9675H9.46911C9.97271 15.02 10.3426 15.4456 10.3426 15.9474C10.3426 16.4492 9.97271 16.8749 9.46911 16.9274C9.41665 16.9799 9.36419 16.9799 9.33796 16.9799ZM9.33796 15.6558C9.15173 15.6558 8.99435 15.8134 8.99435 16C8.99435 16.1865 9.15173 16.3441 9.33796 16.3441H9.36419C9.52157 16.3179 9.65534 16.1839 9.65534 16.0263C9.65534 15.8686 9.52419 15.7083 9.36419 15.7083C9.36419 15.6558 9.33796 15.6558 9.33796 15.6558Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2645 22.1451C20.9996 22.1451 20.7609 22.0401 20.551 21.8535C20.4724 21.7747 20.4199 21.6959 20.3648 21.5882C20.0212 20.9261 20.5222 20.1589 21.2383 20.1589C21.3983 20.1589 21.5819 20.2115 21.713 20.2903C21.7917 20.3428 21.8704 20.3954 21.9255 20.4479C22.3215 20.8447 22.3215 21.4542 21.9255 21.8509C21.7681 22.0374 21.5294 22.1425 21.2645 22.1425V22.1451ZM21.2645 20.821C21.1858 20.821 21.1071 20.8473 21.0258 20.9261C20.9209 21.0312 20.8947 21.1915 20.9733 21.2965C20.9996 21.3228 20.9996 21.3491 21.0258 21.3754C21.0783 21.4279 21.1832 21.4804 21.2645 21.4804C21.3458 21.4804 21.4219 21.4542 21.5032 21.3754C21.6343 21.244 21.6343 21.0312 21.5032 20.8972C21.477 20.8709 21.4507 20.8447 21.4245 20.8447C21.372 20.8447 21.3196 20.8184 21.2671 20.8184L21.2645 20.821Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3733 12.0276C11.1609 12.0276 10.9773 11.975 10.7911 11.8411C10.7386 11.8148 10.7124 11.7622 10.6599 11.736C10.2638 11.3392 10.2638 10.7297 10.6599 10.333C10.8461 10.1465 11.0822 10.0414 11.3733 10.0414C11.6907 10.0414 11.9819 10.2016 12.1943 10.4644C12.4592 10.8611 12.433 11.3918 12.0894 11.736C11.772 12.0539 11.376 12.0276 11.376 12.0276H11.3733ZM11.3733 10.7008C11.2947 10.7008 11.216 10.7271 11.1347 10.8059C11.0035 10.9373 11.0035 11.1501 11.1347 11.2841C11.1347 11.2841 11.1609 11.3103 11.1871 11.3103C11.2396 11.3629 11.3183 11.3629 11.3733 11.3629C11.6383 11.3629 11.7956 11.0713 11.6383 10.8322C11.6383 10.8059 11.612 10.8059 11.612 10.7796C11.5596 10.7534 11.4547 10.7008 11.3733 10.7008Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3204 11.0739C16.1341 11.0739 15.9767 10.9136 15.9767 10.7297V9.64465C15.9767 9.45811 16.1341 9.30048 16.3204 9.30048C16.5066 9.30048 16.664 9.45811 16.664 9.64465V10.7297C16.664 10.9425 16.5066 11.0739 16.3204 11.0739Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7853 12.5294C19.6541 12.398 19.6541 12.1852 19.7853 12.0539L20.5511 11.2867C20.6823 11.1553 20.8948 11.1553 21.0259 11.2867C21.1571 11.4181 21.1571 11.6309 21.0259 11.7622L20.26 12.5294C20.1289 12.6608 19.9164 12.6608 19.7853 12.5294Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6121 20.9261C11.4809 20.7948 11.4809 20.5819 11.6121 20.448L12.378 19.6808C12.5091 19.5494 12.7216 19.5494 12.8528 19.6808C12.9839 19.8122 12.9839 20.025 12.8528 20.159L12.0868 20.9261C11.9557 21.0575 11.7432 21.0575 11.6121 20.9261Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.639 16.3179H21.5557C21.3695 16.3179 21.2121 16.1577 21.2121 15.9737C21.2121 15.7898 21.3695 15.6296 21.5557 15.6296H22.639C22.8252 15.6296 22.9826 15.7898 22.9826 15.9737C22.9826 16.1866 22.8252 16.3179 22.639 16.3179Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0848 16.3179H10.0015C9.81528 16.3179 9.6579 16.1577 9.6579 15.9737C9.6579 15.7898 9.81528 15.6296 10.0015 15.6296H11.0848C11.271 15.6296 11.4284 15.7898 11.4284 15.9737C11.4022 16.1866 11.271 16.3179 11.0848 16.3179Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7898 21.0338C20.7111 21.0338 20.6325 21.0076 20.5511 20.9287L19.7853 20.1616C19.6541 20.0302 19.6541 19.8174 19.7853 19.6834C19.9164 19.5521 20.1289 19.5521 20.26 19.6834L21.0259 20.4506C21.1571 20.5819 21.1571 20.7948 21.0259 20.9287C20.9734 20.9813 20.8685 21.0338 20.7872 21.0338H20.7898Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3806 12.5294L11.6147 11.7622C11.4835 11.6309 11.4835 11.4181 11.6147 11.2867C11.7458 11.1553 11.9583 11.1553 12.0894 11.2867L12.8553 12.0539C12.9865 12.1852 12.9865 12.398 12.8553 12.5294C12.7242 12.6608 12.5117 12.6608 12.3806 12.5294Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3202 14.0401C15.528 14.0401 14.7333 13.9612 13.9674 13.801C13.2539 13.6696 12.5667 13.4568 11.932 13.1652C11.7746 13.0864 11.6933 12.8998 11.7458 12.7422C11.8244 12.5846 12.0107 12.5031 12.168 12.5557C12.7503 12.821 13.3851 13.0049 14.0723 13.1389C14.7858 13.2703 15.528 13.3517 16.2939 13.3517C17.0598 13.3517 17.8021 13.2729 18.5156 13.1389C19.1766 13.0075 19.8113 12.7947 20.4198 12.5557C20.5772 12.4768 20.7897 12.5557 20.8421 12.7422C20.9208 12.8998 20.8421 13.1126 20.6559 13.1652C20.0212 13.4305 19.3339 13.6407 18.6205 13.801C17.9071 13.9586 17.1123 14.0401 16.3202 14.0401Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.155 19.3892C18.9641 18.911 17.6422 18.7009 16.3202 18.7009C15.5543 18.7009 14.812 18.7797 14.0986 18.9137C13.5425 19.0188 12.989 19.179 12.4854 19.3918C12.4068 19.6572 12.0632 19.736 11.9032 19.5232C11.8769 19.4969 11.8507 19.4444 11.8245 19.4181C11.6933 19.2316 11.772 18.9951 11.9556 18.9137C12.5904 18.6483 13.2513 18.4381 13.9648 18.3041C14.7307 18.1439 15.5254 18.0651 16.3176 18.0651C17.1097 18.0651 17.9045 18.1439 18.6704 18.3041C19.3838 18.4355 20.071 18.6483 20.6795 18.9399C20.8658 19.0188 20.9445 19.2578 20.8107 19.4706C20.7845 19.4969 20.7582 19.5495 20.732 19.5757C20.5746 19.736 20.2284 19.6546 20.1497 19.3892H20.155Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2678 21.667C15.1583 21.6407 14.2062 20.5294 13.7026 18.6746C13.4901 17.8811 13.3589 16.9537 13.3589 16.0263C13.3589 15.0989 13.4639 14.1977 13.7026 13.378C14.2062 11.5494 15.1583 10.4118 16.2678 10.3856H16.3465C17.456 10.4118 18.4081 11.5232 18.9117 13.378C19.3603 15.02 19.3603 17.0325 18.9117 18.6746C18.4081 20.5031 17.4586 21.6407 16.3465 21.667H16.2678ZM16.3465 21.0049C17.1124 20.9787 17.8809 19.9987 18.277 18.5143C18.4894 17.7734 18.5944 16.8985 18.5944 16.0499C18.5944 15.2013 18.4894 14.3291 18.277 13.5856C17.8809 12.1012 17.1124 11.1212 16.3465 11.0949H16.294C15.5281 11.1212 14.7596 12.1012 14.3635 13.5856C14.1511 14.3264 14.0462 15.2013 14.0462 16.0499C14.0462 16.8985 14.1511 17.7708 14.3635 18.5143C14.7596 20.025 15.5281 21.0049 16.294 21.0049H16.3465Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3204 21.667C16.1341 21.667 15.9767 21.5094 15.9767 21.3228V10.7271C15.9767 10.5406 16.1341 10.3829 16.3204 10.3829C16.5066 10.3829 16.664 10.5406 16.664 10.7271V21.3228C16.664 21.5356 16.5066 21.667 16.3204 21.667Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6082 16.3705H11.0298C10.8436 16.3705 10.6862 16.2128 10.6862 16.0263C10.6862 15.8398 10.8436 15.6821 11.0298 15.6821H21.6082C21.7944 15.6821 21.9518 15.8398 21.9518 16.0263C21.9518 16.2128 21.7944 16.3705 21.6082 16.3705Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7123 16.0526V16C10.7385 12.6634 13.6736 10.094 16.926 10.4644C16.9785 10.4644 17.031 10.4644 17.1123 10.4907C17.6421 10.5695 18.1431 10.7035 18.5942 10.9137C20.5247 11.7623 21.9516 13.7222 21.9516 16.0526C21.9516 18.8874 19.8637 21.244 17.1123 21.6145C13.6474 22.09 10.7123 19.4155 10.7123 16.0526ZM17.4296 20.8736C17.6421 20.821 17.9333 20.7422 18.1169 20.6608C18.4867 20.5294 18.8041 20.3429 19.0165 20.1853L19.0428 20.159C19.0428 20.159 19.3077 19.9725 19.5175 19.7885C21.8703 17.7498 21.7916 14.2266 19.5437 12.2667C19.5175 12.2404 19.4913 12.2142 19.4913 12.2142C19.3864 12.1353 19.2526 12.0014 19.0428 11.87C18.408 11.447 17.7208 11.1817 16.9811 11.0766C15.9241 10.9715 14.8644 11.1816 13.9411 11.6861C13.9149 11.6861 13.8887 11.7124 13.8887 11.7124C13.3588 12.004 13.0152 12.2956 12.6716 12.6923C11.8795 13.5409 11.4021 14.7048 11.3759 16.0027V16.0552C11.3759 19.1816 14.2323 21.5908 17.4323 20.8762L17.4296 20.8736Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.1417818a85ca0f6db32a929c2004624f.svg";
export { ForwardRef as ReactComponent };